import * as z from "zod";
import { AnalyticsFilterType } from "./analytics-filter-type";
import { makeReportFilterSchema } from "./base-report-filter";

export enum TagsFilterQuery {
  IS_ANY = "isAny",
  IS_NONE = "isNone",
}

export const TagsFilterSchema = makeReportFilterSchema(
  AnalyticsFilterType.TAGS,
  TagsFilterQuery,
  z.array(z.string()),
);

export type TagsFilter = z.infer<typeof TagsFilterSchema>;
